import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setupData = {
  withJWT: undefined,
  withBasicAuth: true,
  jwt: undefined,
  additionalHeaders: {},
  isVersionIncluded: false,
  SERVICES_BASIC_AUTH: undefined,
  DMS_BASIC_AUTH: undefined,
  GATEWAY_API_URL: '',
  SERVICES_URL_SUFFIX: '',
  DMS_URL_SUFFIX: '',
  CUSTOM_URL_SUFFIX: '',
  DMS_URL: undefined,
  SERVICES_URL: undefined,
  CUSTOM_URL: undefined
};
export var V10 = 'v1.0';
export var V11 = 'v1.1';
export var V20 = 'v2.0';
export var V21 = 'v2.1';
export var setup = function setup(data) {
  setupData = _objectSpread({}, setupData, {}, data);
};
export var getAdditionalHeaders = function getAdditionalHeaders() {
  return setupData.additionalHeaders;
};
export var withJWT = function withJWT() {
  return setupData.withJWT;
};
export var withBasicAuth = function withBasicAuth() {
  return setupData.withBasicAuth;
};
export var getJWT = function getJWT() {
  return setupData.jwt;
};
export var getServicesBasicAuth = function getServicesBasicAuth() {
  return setupData.SERVICES_BASIC_AUTH;
};
export var getDMSBasicAuth = function getDMSBasicAuth() {
  return setupData.DMS_BASIC_AUTH;
};
export var getServicesUrl = function getServicesUrl() {
  var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : V10;

  if (setupData.SERVICES_URL !== undefined) {
    return setupData.isVersionIncluded === true ? "".concat(setupData.SERVICES_URL) : "".concat(setupData.SERVICES_URL, "/").concat(version);
  }

  return "".concat(setupData.GATEWAY_API_URL).concat(setupData.SERVICES_URL_SUFFIX, "/").concat(version);
};
export var getDmsUrl = function getDmsUrl() {
  var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : V10;

  if (setupData.DMS_URL !== undefined) {
    return setupData.isVersionIncluded === true ? "".concat(setupData.DMS_URL) : "".concat(setupData.DMS_URL, "/").concat(version);
  }

  return "".concat(setupData.GATEWAY_API_URL).concat(setupData.DMS_URL_SUFFIX, "/").concat(version);
};
export var getCustomUrl = function getCustomUrl() {
  if (setupData.CUSTOM_URL !== undefined) {
    return "".concat(setupData.CUSTOM_URL);
  }

  return "".concat(setupData.GATEWAY_API_URL).concat(setupData.CUSTOM_URL_SUFFIX);
};